module.exports = {
    env: 'stage',
    baseURL: {
        BASE_URL: process.env.REACT_APP_STAGE_BASE_URL,
    },
    featureFlags: {
        ShowNflBrand: true,
        brandName: 'Asra Soft',
    },
};
